import getFingerprint from 'get-browser-fingerprint';
import md5 from 'md5';

export const getBrowserFingerprint = () => {
  return md5(getFingerprint());
};
